module.exports = __webpack_public_path__ + "static/media/akagi-win.948d8a89.png";